export const MAX_LENGTH_CATEGORY_NAME = 100;
export const CATEGORIES_PAGE_SIZE = 50;
